<template>
  <font-awesome-icon v-if="!success" title="Дать допуск" @click="newAccess(true)" class="submit icon hover" icon="fa-solid fa-circle-check" />
  <font-awesome-icon v-else title="Отменить допуск" @click="newAccess(false)" class="icon  hover denied" icon="fa-solid fa-hand" />
</template>

<script>

export default {
  name: 'success-executor',
  props: ['success'],
  setup(_,{emit}) {

    const newAccess = val =>{
      emit('update',val)
    }
    return {
      newAccess,
    }
  }
};
</script>

<style scoped>

.icon{
  width: 30px;
  height: 30px;
  margin-right: 10px;
  padding: 2px;
  border-radius: 5px;
  color: rgba(145,218,85,1);
}

.submit{
  border: 1px solid rgba(0, 0, 0, 0.4);
}

.denied{
  background-color: rgba(230,230,230, 1);
  border: 1px solid rgba(0, 0, 0, 0.4);
  color: rgba(239,43,43,0.8);
}

.hover:hover{
  background-color: rgba(230,230,230, 1);
  cursor: pointer;
}
</style>
